<template>
  <NewsList />
</template>

<script>
import NewsList from '@/components/content/news/EditNews.vue'

export default {
  name: 'ContentNews',
  components: { NewsList }
}
</script>

<style scoped>

</style>
